export const navBarRouterPathURl = '/frontend/partner_name';
export const partnerNameFromUrl = '/frontend/partner_name';